import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { first } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss',
    '../../../assets/project/css/components.scss',
    '../../../assets/project/css/tggsp.scss'
  ]
})
export class NewsletterComponent implements OnInit {
  subscribeForm: FormGroup;
  isHandsetPortrait: boolean = false;
  activeLanguageTranslations: any = {};
  bannerClass: any ='';
  bannerImage: any ='';
  subscribeText = "Subscribing..";
  submitted = false;
  subscribed = false;
    
  constructor(private dashboardService: DashboardService) {
    this.subscribeForm = new FormGroup({
      emailID: new FormControl('', [Validators.required, Validators.email]),
      firstName: new FormControl('', [Validators.required])
    });
  }

  ngOnInit(): void { }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  onSubscribe() {
    this.submitted = true;
    if(!this.subscribeForm.valid){
      return ;
    }
    if (this.subscribeForm.valid) {
      const formValue = this.subscribeForm.value;
      // formValue['firstName'] = '';
      this.dashboardService.subscribeLetter(formValue).subscribe({
        next: (val) => {
          this.subscribed = true;
          this.subscribeText = "Thank you! Your submission has been received!";
          setTimeout(() => {
            this.subscribeForm.reset();
            this.subscribed = false;
            this.submitted = false;
          }, 10000);
        }, error:(err: any) => {
          this.subscribed = false;
          this.subscribeText = "Oops! Something went wrong while submitting the form.";
          console.log(err);
        }
      });
    }
  }

}
